import { render } from "./EventsListWordcloud.vue?vue&type=template&id=17b5f741&scoped=true"
import script from "./EventsListWordcloud.vue?vue&type=script&lang=js"
export * from "./EventsListWordcloud.vue?vue&type=script&lang=js"

import "./EventsListWordcloud.vue?vue&type=style&index=0&id=17b5f741&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b5f741"]])

export default __exports__